/**
 * Egyptian pound.
 */
export var EGP = {
  code: 'EGP',
  base: 10,
  exponent: 2
};